<script>

    import { onMount, createEventDispatcher } from 'svelte'
    import { Loader } from '@googlemaps/js-api-loader'

    import GoogleMapsMethods from '../$methods/google.maps.methods'
    import InputText from './input.text.svelte'

    const GOOGLE_MAPS_KEY = _CONST_.GOOGLE_MAPS_API_KEY
    const dispatch = createEventDispatcher()

    const loader = new Loader({
        apiKey: GOOGLE_MAPS_KEY,
        version: "weekly",
        libraries: ["places"]
    })

    export let label = null
    export let input = null
    export let location = {}
    export let showZipcode = true

    onMount(() => {

        loader
            .load()
            .then(() => {

                const searchBox = new google.maps.places.SearchBox(input, {
                    componentRestrictions: {
                        country: "mx"
                    }
                })

                searchBox.addListener("places_changed", () => {

                    const places = searchBox.getPlaces()
                    
                    location = GoogleMapsMethods.Location(places[0])

                    dispatch('selected', location)
                    dispatch('updated', location)
                    dispatch('change', location)
                })
            })
    })

    function onChange() {
        dispatch('updated', location)
    }

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <form autocomplete="off">
            <InputText bind:input={input} value={location.address} icon="map-marker-alt" placeholder="Dirección" />
            {#if showZipcode}
                <InputText bind:value={location.zipcode} icon="map-marker-alt" placeholder="Código postal" on:keyup={onChange} />
            {/if}
        </form>
    </div>
</div>